import { render, staticRenderFns } from "./StaffExportMonthlyAttendancePage.vue?vue&type=template&id=4185da1a&scoped=true&"
import script from "./StaffExportMonthlyAttendancePage.vue?vue&type=script&lang=js&"
export * from "./StaffExportMonthlyAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4185da1a",
  null
  
)

export default component.exports